import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/home";
import Discover from "../pages/discover";
import LeaveMark from "../pages/leaveMark";
import PremiumFeatures from "../pages/premiumFeatures";
import Contact from "../pages/contact";
import Team from "../pages/team";
import Subscription from "../pages/subscription";
import Download from "../pages/download";
import BasicPlan from "../pages/plans/basicPlan";
import AdvancedPlan from "../pages/plans/advancedPlan";
import PremiumPlan from "../pages/plans/premiumPlan";
import DynamicPolicy from "../pages/privacy-and-security/DynamicPolicy";
import DeleteRequest from "../pages/deleteRequest";
import ChatScreen from "../pages/QRscreens/chatScreen";
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import ForgotPassword from "../pages/auth/forgotPassword";
import ForgotPasswordConfirm from "../pages/auth/forgotPasswordConfirm";

const AppRouter = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/leave-mark" element={<LeaveMark />} />
      {/* <Route path="/premiumFeatures" element={<PremiumFeatures />} /> */}
      <Route path="/team" element={<Team />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/download" element={<Download />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/v/:venueUUID" element={<ChatScreen />} />
      {/* <Route path="/plans/basicPlan" element={<BasicPlan />} />
      <Route path="/plans/advancedPlan" element={<AdvancedPlan />} />
      <Route path="/plans/premiumPlan" element={<PremiumPlan />} /> */}
      <Route path="/discover" element={<Discover />} />
      
      {/* Dynamic Policy Route */}
      <Route path="/policies/:key" element={<DynamicPolicy />} />
      
      {/* Delete Request Route */}
      <Route path="/delete-request" element={<DeleteRequest />} />

      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/forgot-password-confirm"
        element={<ForgotPasswordConfirm />}
      />
    </Routes>
  );
};

export default AppRouter;
